import {
  LOGIN_SUCCESS,
  LOGOUT_SUCCESS,
  ADD_EVENT_TO_BETSLIP_SUCCESS,
  REMOVE_EVENT_FROM_BETSLIP,
  PLAY_COUPON_SUCCESS,
  DELETE_COUPON_BY_ID_SUCCESS,
  POST_REGISTER_SUCCESS,
  CAMPAIGN_JOIN_SUCCESS,
  ADD_MULTIPLE_EVENTS_TO_BETSLIP,
  SET_LIVE_STREAM_STOP,
  PLAY_TJK_COUPON_SUCCESS,
} from 'Store/constants';

import { logError } from 'Utils/errorHandler';
import History from 'Store/history';
import uuidv4 from 'uuid/v4';
import { GTA_SPORT_TYPE_NAMING } from 'Store/constants/sportTypes';
import {
  setUserAttributes,
  trackOddAdded,
  trackOddRemoved,
  trackPurchase,
  trackPurchaseRefund,
  trackRegistration,
  trackCampaignJoin,
  trackLiveStreamTotalSeconds,
  trackTjkPLay
} from 'Utils/analytics';
import { cartEvents, cartEventsDetail } from 'Utils/dengageEvents';
import { flatten } from 'lodash';
import { trackSignUp } from '../../../utils/analytics';

export const analyticsDataCollector = ({ getState }) => {
  return next => action => {
    // before the action is dispatched

    if (typeof window !== 'undefined') {

      // bet slip and coupon based actions
  
      if (action?.type === REMOVE_EVENT_FROM_BETSLIP) {
        const { oddId } = action.payload;
        const { betSlip: { couponDetails } } = getState();
        const removedEvent = couponDetails.find(detail => detail.eventId == oddId.split(':')[0]);
  
        try {
          const [removedBet] = removedEvent?.bets ?? [];
  
          trackOddRemoved({
            eventId: removedEvent?.eventId,
            eventName: removedEvent?.name,
            eventStartDate: removedEvent?.eventStartDate,
            marketName: removedBet?.marketName,
            betType: removedBet?.betType,
            mbs: removedBet?.mbs,
            sportType: GTA_SPORT_TYPE_NAMING[removedEvent?.sportType],
            eventLeague: removedEvent?.leagueName,
            oddValue: +removedBet?.odd,
            isBanker: removedBet?.banker,
            isLive: removedEvent?.isLive,
            startTime: removedEvent?.startTime
          }, { list: GTA_SPORT_TYPE_NAMING[removedEvent?.sportType] });

          const identifier = uuidv4();

          cartEvents({
            identifier,
            type: 'remove_to_cart',
          });
  
          cartEventsDetail({
            identifier,
            event_name: removedEvent?.name,
            event_id: removedEvent?.eventId,
            sport_type: GTA_SPORT_TYPE_NAMING[removedEvent?.sportType],
            market_name: removedBet?.marketName,
            market_value: removedBet?.odd,
          });

        } catch (error) {
          logError(error);
        }
      }
  
      // after the action is dispatched and store is updated
      // auth and user specific actions
      if (action.type === LOGIN_SUCCESS) {
        const user = action.payload;
        setUserAttributes({
          client_email: user.hashedEmail,
          user_id: user.userId,
          segment: user.segment,
          vip: user.isVip,
          user_balance: user.balance
        },
        {
          user_id: user.userId,
          balance: user.balance
        });
      }
  
      if (action.type === LOGOUT_SUCCESS) {
        setUserAttributes({
          client_email: null,
          user_id: null,
          segment: null,
          vip: null,
          user_balance: null
        });
      }
  
      if (action.type === POST_REGISTER_SUCCESS) {
        console.log('middileware', action );// burada action.payload.userId şeklinde userid yi alabiliyoruz denendi console da görüldü
        trackSignUp(action.payload.userId);
        trackRegistration();
      }
  
      // campaign register
      if (action.type === CAMPAIGN_JOIN_SUCCESS) {
        trackCampaignJoin();
      }
  
  
      // bet slip and coupon based actions
      if (action.type === ADD_EVENT_TO_BETSLIP_SUCCESS) {
        const { payload } = action;
        const [odd] = payload.eventDetails.bets;
        const locationPathname = History.location && History.location.pathname.split('/')[1];
        
        let tabName;
        let tabType;
        
        if (payload.tabName) {
          tabName = payload.tabName;
        } else {
          tabName = locationPathname || 'Anasayfa';
        }

        if (payload.writerName) {
          tabType = payload.writerName;
        }
  
  
        trackOddAdded({
          eventId: payload.event.eventId,
          eventName: payload.eventDetails.name,
          eventStartDate: payload.eventDetails.eventStartDate,
          marketName: odd.marketName,
          betType: odd.betType,
          mbs: odd.mbs,
          sportType: GTA_SPORT_TYPE_NAMING[payload.eventDetails.sportType],
          eventLeague: payload.eventDetails.leagueName,
          oddValue: +odd.odd,
          isBanker: odd.banker,
          isLive: payload.event.isLive,
          startTime: payload.eventDetails.startTime
        }, { list: GTA_SPORT_TYPE_NAMING[payload.eventDetails.sportType] }, tabName, tabType);
        
        const identifier = uuidv4();

        cartEvents({
          identifier,
          type: 'add_to_cart',
        });

        cartEventsDetail({
          identifier,
          event_name: payload.eventDetails.name,
          event_id: payload.event.eventId,
          sport_type: GTA_SPORT_TYPE_NAMING[payload.eventDetails.sportType],
          market_name: odd.marketName,
          market_value: odd.odd,
        });
        
      }
    }
  
    if (action.type === ADD_MULTIPLE_EVENTS_TO_BETSLIP) {
      const { payload } = action;
      const locationPathname = History.location && History.location.pathname.split('/')[1];
        
      let tabName;
        
      if (payload.tabName) {
        tabName = payload.tabName;
      } else {
        tabName = locationPathname || 'Anasayfa';
      }
  
      payload.details.map(item => {
        trackOddAdded({
          eventId: item.bets[0].id.split(':')[0],
          eventName: item.name,
          marketName: item.bets[0].marketName,
          mbs: item.bets[0].mbs,
          sportType: GTA_SPORT_TYPE_NAMING[item.sportType],
          eventLeague: item.leagueName,
          oddValue: +item.bets[0].odd,
          isBanker: item.bets[0].banker,
          isLive: item.isLive,
        }, { list: GTA_SPORT_TYPE_NAMING[item.sportType] }, tabName);

        const identifier = uuidv4();

        cartEvents({
          identifier,
          type: 'add_to_cart',
        });
  
        cartEventsDetail({
          identifier,
          event_name: item.name,
          event_id: item.bets[0].id.split(':')[0],
          sport_type: GTA_SPORT_TYPE_NAMING[item.sportType],
          market_name: item.bets[0].marketName,
          market_value: item.bets[0].odd,
        });

      });
    }
  
    if (action.type === PLAY_COUPON_SUCCESS) {
      const { coupon } = action.payload;
      const { couponDetails = [] } = getState().betSlip;
      const analyticOdds = couponDetails.map(couponDetail => {
        const [bet] = couponDetail?.bets ?? [];
  
        return {
          eventId: couponDetail?.eventId,
          eventName: couponDetail?.name,
          eventStartDate: couponDetail?.eventStartDate,
          marketName: bet?.marketName,
          betType: bet?.betType,
          mbs: bet?.mbs,
          sportType: GTA_SPORT_TYPE_NAMING[couponDetail?.sportType],
          eventLeague: couponDetail?.leagueName,
          oddValue: +bet?.odd,
          isBanker: bet?.banker,
          isLive: couponDetail?.isLive,
          startTime: couponDetail?.startTime
        };
      });
  
      trackPurchase( { coupon, analyticOdds });
    }
  
    if (action.type === DELETE_COUPON_BY_ID_SUCCESS) {
      const { couponId, canceledCouponAmount } = action.payload;
      trackPurchaseRefund(couponId, canceledCouponAmount);
    }
  
    if (action.type === SET_LIVE_STREAM_STOP) {
      const { totalSeconds } = action.payload;
  
      trackLiveStreamTotalSeconds(totalSeconds);
    }

    if (action.type === PLAY_TJK_COUPON_SUCCESS) {
      const { legs, selectedInfos, verify } = getState().horseRacing.betSlip;
      let horseInfoObj = flatten(legs)?.map((horse, index) => {
        return {
          horseName: horse?.name,
          //jockeyName: horse?.tag?.jokeyDetail?.name,
        };
      }).filter( horse => horse.horseName !== undefined );
      const betSlipPlayObj = {
        hippodrome: selectedInfos?.selectedHippodrome?.name,
        ganyan: selectedInfos?.selectedBet?.description,
        runwayType: selectedInfos?.selectedHippodrome?.runwayInfo,
        cost: verify?.data?.body?.cost
      };
      trackTjkPLay(horseInfoObj, betSlipPlayObj);
    }
    
    const returnValue = next(action);
    return returnValue;
  };
};
